export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
export const CAMPAIGN_CODE_REGEX = /^[a-zA-Z0-9-]+$/
